import { Box, Typography } from '@mui/material';
import { BrandMark } from '../layout/BrandMark';
import { HERO_WHITE_95 } from './designTokens';

interface BrandLockupProps {
  /** Mark + wordmark size in px (default 26). */
  size?: number;
  /** Force white text — use on the dark hero panel. */
  dark?: boolean;
}

export function BrandLockup({ size = 26, dark = false }: BrandLockupProps) {
  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1.5 }}>
      <BrandMark size={size} />
      <Typography
        sx={{
          fontSize: `${Math.round(size * 0.69)}px`, // ≈18px at size=26
          fontWeight: 500,
          letterSpacing: '-0.02em',
          lineHeight: 1,
          color: dark ? HERO_WHITE_95 : 'text.primary',
        }}
      >
        Teamlane
      </Typography>
    </Box>
  );
}
